import React, { useEffect, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Col, Pagination, Row, Spin } from 'antd';
import { useCookies } from 'react-cookie';
import VisibilitySensor from 'react-visibility-sensor';

import AccountNav from '../../components/AccountNav/AccountNav';
import AccountNavMobile from '../../components/AccountNavMobile/AccountNavMobile';
import MarketBreadcrumb from '../../components/MarketBreadcrumb/MarketBreadcrumb';
import MarketFooter from '../../components/MarketFooter/MarketFooter';
import MarketSliderCard from '../../components/MarketSliderCard/MarketSliderCard';
import NoSearchResult from '../../components/NoSearchResult/NoSearchResult';
import NotifyMeModal from '../../components/NotifyMeModal/NotifyMeModal';
import OpenPop from '../../components/OpenPop/OpenPop';
import SearchFilter from '../../components/SearchFilter/SearchFilter';
import TradeDrawer from '../PropertyListing/TradeDrawer';
import TradeModal from '../PropertyListing/TradeModal';

import { Images } from '../../config/images';

import useFilters from '../../Hooks/useFilters';
import useMediaQuery from '../../Hooks/useMediaQuery';
import useQuickBuySecondary from '../../Hooks/useQuickBuySecondary';
import { updateFavoriteCount } from '../../store/reducer/favoriteSlice';
import { addOrRemoveToFavouriteAction } from '../../store/reducer/initialOfferingSlice';
import { notifyMeForProperty } from '../../store/reducer/notifyMeSlice';
import {
  fetchSecondaryOfferingListAction,
  updateMobileSecondaryPropertyList,
  updateWebSecondaryPropertyList,
} from '../../store/reducer/secondaryOfferingSlice';
import { maxShareCalculator } from '../../utils/maxShareCalculator';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';

import './MarketPlace.scss';

const MarketplaceSecondary = () => {
  const [openQuickBuy, setOpenQuickBuy] = useState();
  const [cookies, setCookie] = useCookies(['secondaryHeaderMessage']);
  const [screenWidth, setScreenWidth] = useState(0);
  const [mobilePage, setmobilePage] = useState(1);
  const [quickBuyPropertyData, setQuickBuyPropertyData] = useState({});
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [newsLetterChecked, setNewsLetterChecked] = useState(false);
  const [storeNotifyMeData, setStoreNotifyMeData] = useState({});
  const [notifyLoadingId, setNotifyLoadingId] = useState(0);
  const [page, setPage] = useState(1);

  const screenMD = useMediaQuery('(min-width: 1000px)');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const shouldLog = useRef(true);
  const formRef = useRef();

  const propertyListWebData = useSelector((state) => state.secondaryOffering.webData);
  const propertyListMobileData = useSelector((state) => state.secondaryOffering.mobileData);
  const loading = useSelector((state) => state.secondaryOffering.loading);
  const userProfileData = useSelector((state) => state.userData.userData);
  const filterApply = useSelector((state) => state.filters.filterApply);

  const quickBuySecondaryOptions = useQuickBuySecondary(setOpenQuickBuy, quickBuyPropertyData, {});
  const filterOptions = useFilters(setmobilePage);

  useEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    if (shouldLog.current) {
      shouldLog.current = false;
      featchInitialOfferingData();
    }
  }, []);
  const updateSize = () => {
    setScreenWidth(window.innerWidth);
  };
  const onFetchFail = () => {
    if (location?.state?.prevPath) {
      navigate(location.state.prevPath);
    }
    navigate(`/`);
  };
  const featchInitialOfferingData = async () => {
    await dispatch(
      fetchSecondaryOfferingListAction({
        page: page,
        perPage: 10,
        onFail: onFetchFail,
      })
    );
  };

  const onFavouriteFailInitialWeb = async (id) => {
    let updatedArray = propertyListWebData?.data?.properties?.map((item) =>
      item?.propertyId === id ? { ...item, likedByLoggedInUser: item?.likedByLoggedInUser } : item
    );
    const newData = {
      ...propertyListWebData,
      data: {
        ...propertyListWebData?.data,
        properties: updatedArray,
      },
    };
    await dispatch(updateWebSecondaryPropertyList({ ...newData }));
  };

  const handleOnFavoriteClickWeb = async (propertyId) => {
    if (Object.keys(userProfileData).length > 0) {
      let updatedArray = propertyListWebData?.data?.properties?.map((item) => {
        if (item?.propertyId === propertyId) {
          if (!item?.likedByLoggedInUser) {
            dispatch(updateFavoriteCount());
          }
        }
        return item?.propertyId === propertyId ? { ...item, likedByLoggedInUser: !item?.likedByLoggedInUser } : item;
      });
      const newData = {
        ...propertyListWebData,
        data: {
          ...propertyListWebData?.data,
          properties: updatedArray,
        },
      };
      await dispatch(updateWebSecondaryPropertyList({ ...newData }));
      await dispatch(addOrRemoveToFavouriteAction({ propertyId, onFail: (id) => onFavouriteFailInitialWeb(id) }));
    } else {
      navigate('/login');
    }
  };

  const onFavouriteFailInitialMobile = async (id) => {
    let updatedArray = propertyListMobileData?.data?.properties?.map((item) =>
      item?.propertyId === id ? { ...item, likedByLoggedInUser: item?.likedByLoggedInUser } : item
    );
    const newData = {
      ...propertyListMobileData,
      data: {
        ...propertyListMobileData?.data,
        properties: updatedArray,
      },
    };
    await dispatch(updateMobileSecondaryPropertyList({ ...newData }));
  };

  const handleNotifyMe = async (value) => {
    setNotifyLoadingId(value?.id);
    await dispatch(
      notifyMeForProperty(
        Object.keys(userProfileData).length
          ? {
              propertyId: value?.id,
              forSecondary: value?.isSecondary,
              onSuccess: () => {
                setOpen(false);
                setEmail('');
                setNotifyLoadingId(0);
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              },
            }
          : {
              propertyId: storeNotifyMeData?.id,
              forSecondary: storeNotifyMeData?.isSecondary,
              signUpForNewsletter: newsLetterChecked,
              email: value.email,
              onSuccess: () => {
                setOpen(false);
                setEmail('');
                setNotifyLoadingId(0);
                setNewsLetterChecked(false);
                formRef?.current?.resetFields();
              },
            }
      )
    );
  };

  const handleOnFavoriteClickMobile = async (propertyId) => {
    if (Object.keys(userProfileData).length > 0) {
      let updatedArray = propertyListMobileData?.data?.properties?.map((item) =>
        item?.propertyId === propertyId ? { ...item, likedByLoggedInUser: !item?.likedByLoggedInUser } : item
      );
      const newData = {
        ...propertyListMobileData,
        data: {
          ...propertyListMobileData?.data,
          properties: updatedArray,
        },
      };
      await dispatch(updateMobileSecondaryPropertyList({ ...newData }));
      await dispatch(addOrRemoveToFavouriteAction({ propertyId, onFail: (id) => onFavouriteFailInitialMobile(id) }));
    } else {
      navigate('/login');
    }
  };
  return (
    <div className='marketplace marketplaceinitial'>
      {screenMD ? (
        <TradeModal
          quickBuySecondaryOptions={quickBuySecondaryOptions}
          open={openQuickBuy}
          modalState={setOpenQuickBuy}
          quickBuyPropertyData={quickBuyPropertyData}
          isSingleTab={true}
          isSell={'1'}
          featchData={() => {
            filterOptions.handleNextPage(undefined, true);
            setOpenQuickBuy('');
          }}
        />
      ) : (
        <TradeDrawer
          quickBuySecondaryOptions={quickBuySecondaryOptions}
          open={openQuickBuy}
          modalState={setOpenQuickBuy}
          quickBuyPropertyData={quickBuyPropertyData}
          isSell={'1'}
          isSingleTab={true}
          featchData={async () => {
            setmobilePage(0);
            const newData = {
              ...propertyListMobileData,
              data: {
                ...propertyListMobileData?.data,
                properties: [],
              },
            };
            await dispatch(updateMobileSecondaryPropertyList({ ...newData }));
            setOpenQuickBuy('');
          }}
        />
      )}
      <AccountNav />
      <AccountNavMobile />
      <Spin spinning={loading} wrapperClassName={loading && 'ant-spin--fullscreen'} className={loading && 'ant-spin--fullscreen'}>
        <MarketBreadcrumb
          filterApply={filterApply}
          propertyListWebData={propertyListWebData}
          title='Invest'
          market='Realbricks Market'
          link='/marketplace/initial'
          linkText='Explore initial offerings'
        />
        {!(!filterApply && propertyListWebData?.data?.count <= 0) && (
          <SearchFilter
            page='Realbricks Market'
            totalProperties={propertyListWebData?.data?.count ?? 0}
            apiIsSecondary={true}
            filterOptions={filterOptions}
            // handleApplyFilter={handleApplyFilter}
          />
        )}
        {cookies.secondaryHeaderMessage !== 'true' && (
          <OpenPop
            title='Trade your Ownership Shares.'
            description='Capitalize on the opportunity to trade your shares in the peer-to-peer Realbricks market with existing investors to enhance your liquidity. Coming soon.'
            art={Images.openpopsecondary}
            onClose={() =>
              setCookie('secondaryHeaderMessage', true, {
                path: '/marketplace/secondary',
              })
            }
          />
        )}
        <div className='initial-offer-wrapper'>
          {(propertyListWebData?.data?.properties?.length > 0 || propertyListMobileData?.data?.properties?.length > 0) && (
            <div className='container-fluid'>
              {screenWidth > 639 ? (
                <>
                  <Row gutter={[32, 32]}>
                    {propertyListWebData?.data?.properties?.map((item) => (
                      <Col key={item.id} xs={24} sm={12} md={8}>
                        <MarketSliderCard
                          id={item?.propertyId}
                          label={item?.label}
                          multiFamilyTotalUnit={item?.multiFamilyTotalUnit}
                          isSecondary={true}
                          MarketBlockHead={item?.propertyName}
                          images={item?.images && Object.values(item?.images)}
                          Bids={item?.bids}
                          Asks={item?.asks}
                          LastPriceLabel='Last price'
                          LastPrice={`$ ${getUsCurrencyFormat(item?.lastTradedPrice)}`}
                          AllTimeLabel='All time'
                          AllTime={`${getUsCurrencyFormat(item?.allTime)}%`}
                          ShareDivLable='Div yield'
                          ShareDivValue={`${getUsCurrencyFormat(item?.dividendYield)}%`}
                          isFavorite={item?.likedByLoggedInUser}
                          ShareDivTooltip='The dividend percentage is the most recent profit-sharing amount paid by Realbricks to this property’s investors. It is paid, and varies, on a
                          quarterly basis. The dividend percentage is calculated by dividing the dividend payment by the raise amount. The dividend payment you receive
                          will be proportional to your ownership of the property.'
                          NotAvailableTooltip='The Activity shows the number of bids and ask done for the property. Currently there is no data available for bids and asks.'
                          PrimaryButtonBuy={(item?.label === 'New' || item?.label === 'Trending' || !item?.label) && 'Buy now'}
                          isBuyDisabled={
                            item?.ownedEquity >= 9.8 || maxShareCalculator(item?.totalShare, item?.requestedShares, item?.ownedEquity) < 1
                          }
                          GhostNotify={item?.label === 'Coming Soon' && 'Notify me'}
                          LocationProperty={`${item?.cityName}, ${item?.stateName}`}
                          RentFamily={item?.propertyType}
                          notifyLoadingId={notifyLoadingId}
                          BtnClick={() => {
                            setQuickBuyPropertyData(item);
                            setOpenQuickBuy('StepOne');
                          }}
                          notifyMeBtnClick={(value) => {
                            Object.keys(userProfileData).length ? handleNotifyMe(value) : setStoreNotifyMeData(value) || setOpen(true);
                          }}
                          propertyType={item?.propertyType}
                          propertyTypeImage={item?.propertyTypeImage}
                          onFavoriteClick={() => handleOnFavoriteClickWeb(item?.propertyId)}
                        />
                      </Col>
                    ))}
                  </Row>
                  {propertyListWebData?.data?.count > 10 && (
                    <div className='custom-pagination-wrap'>
                      <Pagination
                        defaultCurrent={propertyListWebData?.data?.currentPage}
                        current={propertyListWebData?.data?.currentPage}
                        total={propertyListWebData?.data?.count}
                        showSizeChanger={false}
                        onChange={async (page) => {
                          setPage(page);
                          await filterOptions?.handleNextPage(page, true);
                          window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                          });
                        }}
                      />
                    </div>
                  )}
                </>
              ) : (
                <>
                  <Row gutter={[32, 32]}>
                    {propertyListMobileData?.data?.properties?.map((item) => (
                      <Col key={item.id} xs={24} sm={12} md={8}>
                        <MarketSliderCard
                          id={item?.propertyId}
                          label={item?.label}
                          multiFamilyTotalUnit={item?.multiFamilyTotalUnit}
                          isSecondary={true}
                          MarketBlockHead={item?.propertyName}
                          images={item?.images && Object.values(item?.images)}
                          Bids={item?.bids}
                          Asks={item?.asks}
                          LastPriceLabel='Last price'
                          LastPrice={`$ ${getUsCurrencyFormat(item?.lastTradedPrice)}`}
                          AllTimeLabel='All time'
                          AllTime={`${getUsCurrencyFormat(item?.allTime)}%`}
                          ShareDivLable='Div yield'
                          ShareDivValue={`${getUsCurrencyFormat(item?.dividendYield)}%`}
                          ShareDivTooltip='The dividend percentage is the most recent profit-sharing amount paid by Realbricks to this property’s investors. It is paid, and varies, on a
                          quarterly basis. The dividend percentage is calculated by dividing the dividend payment by the raise amount. The dividend payment you receive
                          will be proportional to your ownership of the property.'
                          NotAvailableTooltip='The Activity shows the number of bids and ask done for the property. Currently there is no data available for bids and asks.'
                          PrimaryButtonBuy={(item?.label === 'New' || item?.label === 'Trending' || !item?.label) && 'Buy now'}
                          isBuyDisabled={item?.ownedEquity >= 9.8}
                          GhostNotify={item?.label === 'Coming Soon' && 'Notify me'}
                          LocationProperty={`${item?.cityName}, ${item?.stateName}`}
                          RentFamily={item?.propertyType}
                          notifyLoadingId={notifyLoadingId}
                          isFavorite={item?.likedByLoggedInUser}
                          BtnClick={() => {
                            setQuickBuyPropertyData(item);
                            setOpenQuickBuy('StepOne');
                          }}
                          notifyMeBtnClick={(value) => {
                            Object.keys(userProfileData).length ? handleNotifyMe(value) : setStoreNotifyMeData(value) || setOpen(true);
                          }}
                          propertyType={item?.propertyType}
                          propertyTypeImage={item?.propertyTypeImage}
                          onFavoriteClick={() => handleOnFavoriteClickMobile(item?.propertyId)}
                        />
                      </Col>
                    ))}
                  </Row>
                  <VisibilitySensor
                    onChange={(value) => {
                      filterOptions?.handleScrolltoBottom(value, mobilePage, propertyListMobileData, true);
                    }}
                  >
                    <div className='agreement__modal__dot'>.</div>
                  </VisibilitySensor>
                </>
              )}
            </div>
          )}
        </div>
        <MarketFooter />
      </Spin>
      {(propertyListWebData?.data?.properties?.length <= 0 || propertyListMobileData?.data?.properties?.length.length <= 0) && (
        <NoSearchResult
          isSecondary={true}
          title='No properties match your filter or search criteria.'
          description='Try adjusting your filters or expanding your search to see more results.'
          filterText='Try removing some other filters to see more results.'
          handleRemoveLeverage={() => filterOptions?.handleRemoveLeverage(true)}
          handleRemoveLocationFilter={() => filterOptions?.handleRemoveLocationFilter(true)}
          handleClearAll={() => filterOptions?.handleResetAllFilters(true)}
        />
      )}
      <NotifyMeModal
        open={open}
        setOpen={setOpen}
        email={email}
        setEmail={setEmail}
        newsLetterChecked={newsLetterChecked}
        setNewsLetterChecked={setNewsLetterChecked}
        handleNotifyMe={handleNotifyMe}
        ref={formRef}
      />
    </div>
  );
};

export default MarketplaceSecondary;
